import { LocalStorageKeys } from '../constants';

/**
 * @function
 * @description Returns the count of custom tokens imported for a given chainId.
 * @param {number | undefined} chainId - ChainId for which to count imported tokens.
 * @returns {number} - The count of imported tokens for the given chainId.
 */
export const countOfCustomTokens = (chainId: number | undefined): number => {
  if (!chainId) return 0;
  try {
    const existingTokens = JSON.parse(localStorage.getItem(LocalStorageKeys.imported_tokens) as string) ?? [];
    if (!existingTokens) return 0;
    return Object.entries(existingTokens[chainId]).length;
  } catch (e) {
    return 0;
  }
};
